import { Divider } from "@atoms/index"

import styles from "./ListItemDivider.module.scss"

export default function ListItemDivider() {
    return (
        <div className={styles.base}>
            <Divider />
        </div>
    )
}
